import React from 'react'
import CarouselCard from './CarouselCard'
import MaximsCarousel from '../Carousel'
import TheMaxims from './TheMaxims'
import RecognizeTeam from './RecognizeTeam'
import Carousel from '../Carousel'

import RightThingImg from '../../../images/carousel/gc.png'
import FurutreSportImg from '../../../images/carousel/na.png'
import ServeAthleteImg from '../../../images/carousel/maxim3.png'
import OffenseImg from '../../../images/carousel/maxim5.png'
import WinImg from '../../../images/carousel/maxim2.png'

import '../Carousel.css'
const MaximsPage = (props) => {
	let cards = [
		<CarouselCard
			title='Do the Right Thing'
			details='This Maxim reflects our belief in accountability to each other and recognizes the importance of how we connect to and serve our communities.'
			img={RightThingImg}
		/>,
		<CarouselCard
			title='Create the Future of Sport'
			details='This Maxim reflects our commitment to innovation. It establishes Nike as a place where inventors and dreamers can achieve the unimaginable.'
			img={FurutreSportImg}
		/>,
		<CarouselCard
			title='Serve Athletes*'
			details='This Maxim is tied to our mission and is at the center of all that we do. Nike employees create product and experiences to serve athletes — or we work in support of the teams that do. No matter the type of work we do, serving athletes is our north star.'
			img={ServeAthleteImg}
		/>,
		<CarouselCard
			title='Be on the Offense Always'
			details='Nike is a growth company — and we demonstrate it by our focus on the consumer. This Maxim represents all aspects of our business and our determination to win.'
			img={OffenseImg}
		/>,
		<CarouselCard
			title='Win as a Team'
			details='Employees provided consistent feedback that teamwork was missing in the previous Maxims. Now it stands by itself as a testament to our commitment to team.'
			img={WinImg}
		/>,
	]
	return (
		<div className={props.status ? 'show' : 'hide'}>
			<div className='section-black ncss-row'>
				<TheMaxims />
			</div>
			<div className='section-white ncss-row'>
				<RecognizeTeam />
			</div>
			<div className='maxims-wrapper'>
				<Carousel list={cards} scrollPos={360} />
			</div>
		</div>
	)
}

export default MaximsPage



// WEBPACK FOOTER //
// ./src/containers/AboutPage/Maxims/index.js